<script setup lang="ts">
const { validateRoute } = useKind();

validateRoute();
</script>

<template>
	<div></div>
</template>
